export default __webpack_public_path__ + "47a0ff222289d24cdf2aac9445c1b0d9.svg";